const level0 = '#20c77f'
const level1 = '#00b8ff'
const level2 = '#ffda00'
const level3 = '#ff9900'
const level4 = '#d82300'
// ''或者'/api'
const baseUrl = '/api'

export { level0, level1, level2, level3, level4, baseUrl }
